import React from 'react';

const SmsIconYellow = () => {
    return (
        <svg
            width="60"
            height="40"
            viewBox="0 0 60 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.1491 8.17948C17.3735 7.72533 22.6275 7.72533 27.8519 8.17948L30.369 8.39828C32.0446 8.54394 33.4797 9.54339 34.2233 10.973C34.3184 11.1559 34.2471 11.3773 34.0718 11.4859L23.6285 17.9507C21.3888 19.3373 18.5646 19.3664 16.2967 18.0263L5.78366 11.814C5.61381 11.7136 5.53585 11.507 5.61239 11.3252C6.29265 9.70925 7.82204 8.55562 9.63209 8.39828L12.1491 8.17948Z"
                fill="#FFC24C"
            />
            <path
                d="M5.60384 14.6116C5.3439 14.458 5.01223 14.6233 4.98193 14.9237C4.55903 19.1164 4.66139 23.3488 5.28898 27.5223C5.61984 29.7225 7.41552 31.4093 9.63209 31.6019L12.1491 31.8208C17.3735 32.2749 22.6275 32.2749 27.8519 31.8208L30.369 31.6019C32.5855 31.4093 34.3812 29.7225 34.7121 27.5223C35.358 23.2272 35.4475 18.8697 34.9808 14.5572C34.9481 14.2547 34.6108 14.0925 34.352 14.2526L24.9444 20.0764C21.9141 21.9523 18.0932 21.9916 15.0249 20.1786L5.60384 14.6116Z"
                fill="#FFC24C"
            />
            <line
                x1="58"
                y1="8.74228e-08"
                x2="58"
                y2="40"
                stroke="white"
                strokeWidth="4"
            />
        </svg>
    );
};

export default SmsIconYellow;
